import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Widget } from '../../../viewmodels/dashboard/widget';
import { DashboardService } from '../dashboard.service';

@Injectable({
  providedIn: 'root',
})
export class ItemizedWidgetDataService {

  constructor(private dashboardService: DashboardService) { }

  public getCount(widget: Widget): Observable<number> {
    return this.dashboardService.getItemizedWidgetDataCount(widget);
  }

  public getItemizedData(widget: Widget, first: number, quantity: number): Observable<any> {
    return this.dashboardService.getItemizedWidgetData(widget, first, quantity);
  }
}
